<div class="modal-header">
  @if (isNewSignal) {
    <h4 class="modal-title" translate>New signal</h4>
  }
  @if (!isNewSignal) {
    <h4 class="modal-title" translate>Edit signal</h4>
  }
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form (ngSubmit)="onSave()" [formGroup]="signalForm">
  <div class="modal-body">

    <!--TABLE & SIGNAL-->
    <div class="row">
      <!--TABLE-->
      <div class="col-12 col-lg-6">
        <div class="form-group has-feedback">
          <label for="table" translate>Table</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          @if (isLoadingTables) {
            <span class="fa-solid fa-spinner fa-spin"></span>
          }
          <ng-select (change)="onChangeTable($event)" [items]="tables"
            [ngClass]="{ 'is-invalid': formControls.table.errors }"
            formControlName="table" id="table">
          </ng-select>
          @if (formControls.table.errors) {
            <div class="invalid-feedback">
              @if (formControls.table.errors?.required) {
                <span translate>Table required</span>
              }
            </div>
          }
        </div>
      </div>
      <!--SIGNAL-->
      <div class="col-12 col-lg-6">
        <div class="form-group has-feedback">
          <label for="signal" translate>Signal</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          @if (isLoadingSignals) {
            <span class="fa-solid fa-spinner fa-spin"></span>
          }
          <ng-select (change)="onSignalChange($event)"
            [items]="signalNames"
            [ngClass]="{ 'is-invalid': formControls.signal.errors }"
            formControlName="signal" id="signal">
          </ng-select>
          @if (formControls.signal.errors) {
            <div class="invalid-feedback">
              @if (formControls.signal.errors?.required) {
                <span translate>Signal required</span>
              }
            </div>
          }
        </div>
      </div>
    </div>

    @if (signal.usedInTriggers) {
      <div class="alert alert-warning">
        <span [innerHtml]="'Signal cannot be edited because it is used in the following triggers:' | translate"
          class="d-block">
        </span>
        @for (tc of signal.usedInTriggers; track tc) {
          <span [innerText]="tc"
          class="badge badge-warning text-white mr-1"></span>
        }
      </div>
    }

    <div class="divider"></div>

    <!--SIGNAL NAME & LABEL-->
    <div class="row">
      <!--SIGNAL NAME-->
      <div class="col-12 col-lg-6">
        <div class="form-group has-feedback">
          <label for="signalName" translate>Name</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input (input)="signalNameChanged()"
            [ngClass]="{ 'is-invalid': formControls.signalName.errors || signalNameUsed }"
            class="form-control"
            formControlName="signalName"
            id="signalName"
            name="signalName"
            type="text">
            @if (formControls.signalName.errors) {
              <div class="invalid-feedback">
                @if (formControls.signalName.errors?.required) {
                  <span translate> Signal name required</span>
                }
              </div>
            }

            @if (formControls.signalName.errors?.pattern) {
              <span class="help-block" translate> Signal name contains invalid symbols. Not allowed: {{ '{' }}
              , {{ '}' }}, $, # </span>
            }
            @if (signalNameUsed) {
              <span class="invalid-feedback" translate> Signal name already used!</span>
            }

          </div>
        </div>
        <!--SIGNAL LABEL-->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="signalLabel" translate>Label</label>
            <scitis-required-field-indicator></scitis-required-field-indicator>
            <input (change)="signalLabelChanged()" (focus)="signalLabelChanged()"
              [ngClass]="{ 'is-invalid': formControls.signalLabel.errors || signalLabelUsed }"
              class="form-control"
              formControlName="signalLabel"
              id="signalLabel"
              name="signalLabel"
              type="text">
              @if (formControls.signalLabel.errors) {
                <div class="invalid-feedback">
                  @if (formControls.signalLabel.errors?.required) {
                    <span translate> Signal label required</span>
                  }
                </div>
              }

              @if (signalLabelUsed) {
                <span class="invalid-feedback" translate> Signal label already used!</span>
              }

            </div>
          </div>
        </div>

        <!--SIGNAL SCALE & UNIT & PRECISION & COLOR-->
        @if (displaySignalDetails()) {
          <div class="row">
            <!--SIGNAL SCALE-->
            <div class="col-12 col-lg-3">
              <div class="form-group has-feedback">
                <label for="signalScale" translate>Scale</label>
                <input (change)="signalScaleChanged()" class="form-control" formControlName="signalScale" id="signalScale"
                  name="signalScale"
                  type="number">
                  @if (formControls.signalScale.errors) {
                    <div class="invalid-feedback">
                      @if (formControls.signalScale.errors?.pattern) {
                        <span translate>The value is not a valid number!</span>
                      }
                    </div>
                  }
                </div>
              </div>
              <!--SIGNAL UNIT-->
              <div class="col-12 col-lg-3">
                <div class="form-group has-feedback">
                  <label for="signalUnit" translate>Unit</label>
                  <input (change)="signalUnitChanged()" class="form-control" formControlName="signalUnit" id="signalUnit"
                    name="signalUnit"
                    type="text">
                  </div>
                </div>
                <!--SIGNAL Decimal Places-->
                <div class="col-12 col-lg-3">
                  <div class="form-group has-feedback">
                    <label for="signalPrecision" translate>Decimals</label>
                    <input (change)="signalPrecisionChanged()" [ngClass]="{ 'is-invalid': formControls.signalPrecision.errors }"
                      class="form-control"
                      formControlName="signalPrecision"
                      id="signalPrecision"
                      max="9" min="0"
                      name="signalPrecision"
                      type="number">
                      @if (formControls.signalPrecision.errors) {
                        <div class="invalid-feedback">
                          @if (formControls.signalPrecision.errors?.pattern) {
                            <span translate>The value is not a valid integer!</span>
                          }
                        </div>
                      }
                      @if (formControls.signalPrecision.errors) {
                        <div class="invalid-feedback">
                          @if (formControls.signalPrecision.errors?.min) {
                            <span translate>This value can't be negative!</span>
                          }
                          @if (formControls.signalPrecision.errors?.max) {
                            <span
                            translate>A maximum of 9 decimal places can be entered</span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <!-- SIGNAL COLOR-->
                  <div class="col-12 col-lg-3">
                    <scitis-color-picker (selectedColor)="onSelectedColor($event)"
                      [signalColor]="signal.signalColor"
                    [disabled]="!isHigherThanAdmin"></scitis-color-picker>
                  </div>
                </div>
              }

              <!-- SIGNAL COLOR & TYPE-->
              <div class="row">
                @if (!displaySignalDetails()) {
                  <div class="col-12 col-lg-6">
                    <scitis-color-picker (selectedColor)="onSelectedColor($event)"
                      [signalColor]="signal.signalColor"
                    [disabled]="!isHigherThanAdmin"></scitis-color-picker>
                  </div>
                }
                <div [ngClass]="{'col-lg-6': !displaySignalDetails()}" class="col-12">
                  <!-- Error word -->
                  <div class="form-group">
                    <label translate>Type</label>
                    <ng-select (change)="onTypeChange($event)" [(ngModel)]="signalType" [items]="translatedSignalTypes"
                      [disabled]="!isHigherThanAdmin"
                      [ngModelOptions]="{standalone: true}"
                      bindLabel="value" bindValue="key">
                    </ng-select>
                  </div>
                </div>
              </div>

              @if (!isCommandModeDisabled) {
                <div class="row">
                  <div class="col-12 col-lg-3">
                    <div class="form-group has-feedback">
                      <label for="minWritableValue" translate>Min value</label>
                      <input class="form-control" formControlName="minWritableValue" id="minWritableValue"
                        name="minWritableValue"
                        type="number">
                      </div>
                    </div>
                    <div class="col-12 col-lg-3">
                      <div class="form-group has-feedback">
                        <label for="maxWritableValue" translate>Max value</label>
                        <input class="form-control" formControlName="maxWritableValue" id="maxWritableValue"
                          name="maxWritableValue" [ngClass]="{ 'is-invalid': formControls.maxWritableValue.errors }"
                          type="number">
                          @if (formControls.maxWritableValue.errors) {
                            <div class="invalid-feedback">
                              @if (formControls.maxWritableValue.errors?.min) {
                                <span translate>The max value cannot be smaller than the min value</span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-auto writable">
                        <div class="custom-control custom-switch d-inline-flex">
                          <input class="custom-control-input"
                            formControlName="writable"
                            name="writable"
                            id="writable"
                            type="checkbox">
                            <label class="custom-control-label ms-1" for="writable" translate>Writable</label>
                          </div>
                        </div>
                      </div>
                    }

                    @if (signalType === errorSignalType) {
                      <scitis-status-event-signal-configuration
                        [isLoadingDetails]="isLoadingErrorSignalDetails"
                        [isHigherThanAdmin]="isHigherThanAdmin"
                        [signal]="signal">
                      </scitis-status-event-signal-configuration>
                    }

                    <scitis-apply-to-machines-of-same-tag-warning
                      [applyToMachinesOfSameTagMessage]="applyToMachinesOfSameTagMessage"
                      [applyToMachinesOfSameTag]="applyToMachinesOfSameTag">

                    </scitis-apply-to-machines-of-same-tag-warning>


                  </div>

                  <scitis-modal-footer
                    (cancelButtonPressed)="onCancel()"
                    (okButtonPressed)="onSave()"
                    [cancelButtonText]="'Cancel'|translate"
                    [disableOkButton]="isDisabledSaveBtn"
                    [okButtonText]="'Save'|translate"
                    [showRequiredFieldsIndicator]="true">

                  </scitis-modal-footer>

                </form>
